import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  href: string;
  children: React.ReactNode;
  className?: string;
}
export const CTAButton: React.FC<CTAButtonProps> = ({
  href,
  children,
  className = ''
}) => {
  return <motion.a href={href} className={`inline-block bg-gradient-to-br from-gold-main to-gold-dark text-[#1A1A1A] py-4 px-8 md:py-5 md:px-14 text-base md:text-xl font-black font-sans rounded-lg shadow-[0_8px_30px_rgba(255,165,0,0.5)] uppercase tracking-wide text-center ${className}`} animate={{
    boxShadow: ['0 8px 30px rgba(255,165,0,0.5)', '0 8px 50px rgba(255,165,0,0.9)', '0 8px 30px rgba(255,165,0,0.5)']
  }} transition={{
    duration: 2,
    repeat: Infinity,
    ease: 'easeInOut'
  }} whileHover={{
    y: -3
  }} data-id="element-74" data-mp="2kzziwxyx9owh">
      {children}
    </motion.a>;
};